export default "__VITE_ASSET__BLJbRUlb__"